import { useEffect, useState } from "react";
import { useRouterState } from "@tanstack/react-router";
import { isStaleChunkError, reloadForNewDeploy } from "../../lib/stale-deploy";
import { ErrorPage, getErrorStatusFromUnknown } from "../../features/errors";
import { Footer } from "../layout/footer";

function isFooterHiddenRoute(pathname: string) {
  return (
    pathname.endsWith("/packages") ||
    pathname.endsWith("/details") ||
    pathname.endsWith("/checkout") ||
    pathname.endsWith("/discover") ||
    pathname.endsWith("/thank-you") ||
    pathname.endsWith("/bucket") ||
    pathname.endsWith("/bucket/checkout")
  );
}

export function ErrorFallback({ error }: { error: Error }) {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const shouldRenderFooter = isFooterHiddenRoute(pathname);
  // A chunk from before the latest deploy is gone: reload into the new build
  // instead of flashing the 500 page. This lives here rather than in the root
  // errorComponent, because a lazy route's failure is caught by that route's
  // own boundary (the default one) and never reaches the root. Falls through
  // to the error page if a reload already happened in the last minute.
  const staleChunk = isStaleChunkError(error);
  const [reloading, setReloading] = useState(staleChunk);
  useEffect(() => {
    if (staleChunk && !reloadForNewDeploy()) setReloading(false);
  }, [staleChunk]);

  if (reloading) return null;

  return (
    <>
      <ErrorPage
        status={getErrorStatusFromUnknown(error)}
        details={import.meta.env.DEV ? error.message : undefined}
      />
      {shouldRenderFooter ? <Footer /> : null}
    </>
  );
}
